import { Region } from 'wavesurfer.js/src/plugin/regions';

export const NUM_MICROSEC_IN_A_SEC = 1_000_000;

export const enum AudioAnnotationTypes {
  NoAnnotations = 'NoAnnotations', // Base player (no annotations). Unmuted and has optional spectrogram
  Wail = 'Wail',
  Yelp = 'Yelp',
  Piercer = 'Piercer',
  Horn = 'Horn',
  Other = 'Other',
}

export function getRegionColorForType(
  type: AudioAnnotationTypes,
  alpha: number
): string {
  switch (type) {
    case 'Wail':
      return `rgba(206, 66, 245, ${alpha})`;
    case 'Yelp':
      return `rgba(0, 0, 255, ${alpha})`;
    case 'Piercer':
      return `rgba(214, 0, 18, ${alpha})`;
    case 'Horn':
      return `rgba(245, 215, 66, ${alpha})`;
    case 'Other':
      return `rgba(255, 132, 0, ${alpha})`;
    default:
      return 'gray';
  }
}

// Name that the backend uses
export type SirenCategoryName =
  | 'siren.wail'
  | 'siren.piercer'
  | 'siren.horn'
  | 'siren.yelp'
  | 'siren.other';

export function getSirenCategoryName(
  audioAnnotationType: AudioAnnotationTypes
): SirenCategoryName {
  return ('siren.' + audioAnnotationType.toLowerCase()) as SirenCategoryName;
}

export function getAnnotationTypeFromCategoryName(
  categoryName: string
): AudioAnnotationTypes | null {
  const name = categoryName.split('.');
  return name.length > 1
    ? ((name[1].charAt(0).toUpperCase() +
        name[1].slice(1)) as AudioAnnotationTypes)
    : null;
}

export const NUM_ANNOTATION_TYPES = 5;

export const colorForAudioType = {
  LockedColors: {
    waveColor: 'lightgray',
    progressColor: '#A9A9A9',
  },
  UnlockedColors: {
    waveColor: '#A9A9A9',
    progressColor: 'gray',
  },
};

export const enum RegionColors {
  Unselected = 'rgba(0, 0, 0, 0.16)',
  Highlight = 'rgba(0, 0, 0, 0.08)',
  Playing = 'rgba(255, 213, 0, 0.3)', // yellow
  Selected = 'rgba(0, 255, 247, 0.5)',
}

const REGION_MIN_LENGTH_IN_SEC = 0.5; // Specified by Perception.

export const minLengthForRegion = {
  NoAnnotations: 0.001,
  Wail: REGION_MIN_LENGTH_IN_SEC,
  Yelp: REGION_MIN_LENGTH_IN_SEC,
  Piercer: REGION_MIN_LENGTH_IN_SEC,
  Horn: 0.001,
  Other: REGION_MIN_LENGTH_IN_SEC,
};

export interface AnnotationRegion extends Region {
  token?: string; // Once an annotation has been saved to the backend, this will be set to the corresponding token for that annotation, for future PATCH or DELETE operations
  annotationType?: AudioAnnotationTypes;
}

export const enum TaskModes {
  Label = 'label',
  QA = 'qa',
}
